import { render, staticRenderFns } from "./AdminTransactionActions.vue?vue&type=template&id=004bc417&"
import script from "./AdminTransactionActions.vue?vue&type=script&lang=ts&"
export * from "./AdminTransactionActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports